import { useRouter } from '@redneckz/wildless-cms-uni-blocks';
import { type Router } from '@redneckz/wildless-cms-uni-blocks/lib/hooks/useRouter';
import { Heading } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Heading/Heading';
import { type Option } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Select/Option';
import { Text } from '@redneckz/wildless-cms-uni-blocks/lib/ui-kit/Text/Text';
import { Link } from 'gatsby';
import React, { useMemo } from 'react';
import { NewsFilterSelects } from './NewsFilterSelects';

interface NewsFilterProps {
  hideCategories?: boolean;
  categories?: Queries.Maybe<Queries.PortalResourcesJsonItems>[];
}

export const NewsFilter = ({ categories, hideCategories }: NewsFilterProps) => {
  const router = useRouter();

  const categoriesOptions: Option[] = useMemo(
    () =>
      categories
        ? ([
            { text: 'Все', key: '/' },
            ...categories.map((_) => ({
              key: _?.key,
              text: _?.value,
            })),
          ] as Option[])
        : [{ text: 'Все', key: '/' }],
    [categories],
  );

  return !hideCategories ? (
    <div className="col-span-12 p-6xl sm:p-3xl bg-white space-y-m w-full sm:w-auto">
      <Heading className="hidden sm:block" headingType="h6" as="h4">
        Фильтры
      </Heading>
      <div className="flex-col gap-m hidden sm:flex">
        <Link to="/">
          <Text
            size="text-l"
            color={
              categories?.find((_) => checkIsCategoryChosen(router, _?.key))
                ? 'text-green'
                : 'text-primary-text'
            }
          >
            Все категории
          </Text>
        </Link>
        {categories?.map(renderCategory(router))}
      </div>
      <NewsFilterSelects categories={categoriesOptions} />
    </div>
  ) : null;
};

const renderCategory =
  (router: Router) => (category: Queries.Maybe<Queries.PortalResourcesJsonItems>) =>
    (
      <Link key={category?.key} to={category?.key ? `/${category?.key}` : '/'}>
        <Text
          size="text-l"
          color={checkIsCategoryChosen(router, category?.key) ? 'text-primary-text' : 'text-green'}
        >
          {category?.value}
        </Text>
      </Link>
    );

const checkIsCategoryChosen = (router: Router, key?: string | null) =>
  router.pathname.includes(key ?? '');
